/* ─────────────────────────────────────────────────────────────────────────
   Pavos header — desktop mega menu only.
   Opens on hover and keyboard focus, closes on mouseleave, Escape, focus
   leaving the header, or hovering a close zone (logo / icons / plain links).
   Drawers (#MobileMenu, #SearchModal, #CartDrawer) are handled by global.js.
   ──────────────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  var desktop = window.matchMedia('(min-width: 1024px)');

  function initHeader(header) {
    if (header.dataset.megaInit === 'true') return;
    header.dataset.megaInit = 'true';

    var triggers = Array.prototype.slice.call(
      header.querySelectorAll('[data-mega-trigger]')
    );
    var panels = Array.prototype.slice.call(
      header.querySelectorAll('[data-mega-panel]')
    );

    if (!panels.length) return;

    function closeAll() {
      panels.forEach(function (panel) {
        panel.classList.remove('is-open');
      });
      triggers.forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });
      header.classList.remove('is-mega-open');
    }

    function open(id) {
      if (!desktop.matches) return;
      var panel = header.querySelector('[data-mega-panel="' + id + '"]');
      if (!panel) {
        closeAll();
        return;
      }
      if (panel.classList.contains('is-open')) return;
      closeAll();
      panel.classList.add('is-open');
      header.classList.add('is-mega-open');
      triggers.forEach(function (trigger) {
        if (trigger.getAttribute('data-mega-trigger') === id) {
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    }

    triggers.forEach(function (trigger) {
      var id = trigger.getAttribute('data-mega-trigger');
      var item = trigger.closest('[data-mega-item]') || trigger;
      item.addEventListener('mouseenter', function () {
        open(id);
      });
      trigger.addEventListener('focus', function () {
        open(id);
      });
    });

    /* Logo, icons, and links without children quietly close the panel. */
    Array.prototype.forEach.call(
      header.querySelectorAll('[data-mega-close-zone]'),
      function (zone) {
        zone.addEventListener('mouseenter', closeAll);
      }
    );

    header.addEventListener('mouseleave', closeAll);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll();
    });

    /* Keyboard focus travelling past the header closes the panel. */
    header.addEventListener('focusout', function (event) {
      if (!desktop.matches) return;
      if (event.relatedTarget && !header.contains(event.relatedTarget)) {
        closeAll();
      }
    });

    /* Leaving desktop widths drops any open panel. */
    var onChange = function (event) {
      if (!event.matches) closeAll();
    };
    if (typeof desktop.addEventListener === 'function') {
      desktop.addEventListener('change', onChange);
    } else if (typeof desktop.addListener === 'function') {
      desktop.addListener(onChange);
    }
  }

  function init() {
    var header = document.querySelector('[data-header]');
    if (header) initHeader(header);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor re-renders */
  document.addEventListener('shopify:section:load', function (event) {
    var header = event.target.querySelector('[data-header]');
    if (header) initHeader(header);
  });
})();
